import { useEffect, useMemo, useState, type ReactNode } from 'react'
import { ThemeContext, type Theme } from './themeContextDef'

export function ThemeProvider({ children }: Readonly<{ children: ReactNode }>) {
  const [theme, setTheme] = useState<Theme>(() => {
    if (globalThis.window !== undefined) {
      const saved = localStorage.getItem('anotherwhy-theme') as Theme
      if (saved) return saved
    }
    return 'dark'
  })

  useEffect(() => {
    const root = document.documentElement
    root.dataset.theme = theme
    // Also toggle .dark class for shadcn/ui compatibility
    if (theme === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
    localStorage.setItem('anotherwhy-theme', theme)
  }, [theme])

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'))
  }

  const value = useMemo(() => ({ theme, toggleTheme }), [theme])

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}
